import React from "react";
export default function FeatureCard(props) {
  return (
    <>
    <div className="feature-card" style={{ borderBottom : props.border }}>
      <div className="card-image">
      <img src={props.icon} alt={props.title} style={{width:'100%', height:'100%'}}/>
      </div>
      <p className="custom-title">{props.title}</p>
      <p>{props.description}</p>
    </div>
    </>
  );
}


  